
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('visio2Display.vrun.component', () => import ('./components/Visio2Display.vue'))



